import React from 'react';
import SectionSubtitle from './SectionSubtitle';
import SectionTitle from './SectionTitle';

interface SectionHeaderProps {
  // Il titolo può essere passato come children o come stringa semplice
  title: React.ReactNode;
  // Il sottotitolo è opzionale e viene passato come stringa
  subtitle?: React.ReactNode;
  // Permette di passare classi CSS extra (es. per margini o allineamento)
  className?: string;
  // Permette di invertire o modificare la direzione del flex (default: colonna)
  direction?: 'col' | 'row';
  gridSpan?: boolean;
}

const SectionHeader = ({
  title,
  subtitle,
  className = '',
  direction = 'col',
  gridSpan = false
}: SectionHeaderProps) => {
  const flexDirection = direction === 'row' ? 'flex-row items-center gap-4' : 'flex-col';

  const content = (
    <div className={`flex ${flexDirection} ${className}`}>
      {/* Se il titolo è una stringa/nodo lo inseriamo dentro SectionTitle */}
      <SectionTitle>{title}</SectionTitle>

      {/* Mostra il sottotitolo solo se viene effettivamente passato */}
      {subtitle && <SectionSubtitle text={subtitle} />}
    </div>
  );

  if (gridSpan) {
    return <div style={{ gridColumn: '1 / -1' }}>{content}</div>;
  }

  return content;
};

export default SectionHeader;
